import { Component, OnInit, } from '@angular/core';
import { slideToTop } from '../../router-animation/router-animation.component';
import { Router, ActivatedRoute } from '@angular/router';
import { DatabaseService } from 'src/_services/DatabaseService';
import { StatusModalComponent } from '../status-modal/status-modal.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { splitClasses } from '@angular/compiler';
import { sessionStorage } from 'src/app/localstorage.service';
import { OrderEditModalComponent } from '../order-edit-modal/order-edit-modal.component';
import { OrderDispatchComponent } from '../order-dispatch/order-dispatch.component';
import { DialogComponent } from 'src/app/dialog.component';
import { ToastrManager } from 'ng6-toastr-notifications';
// import * as ExcelJS from 'exceljs';
import * as $ from "jquery";
import { ImageModuleComponent } from 'src/app/image-module/image-module.component';


@Component({
    selector: 'app-order-detail',
    templateUrl: './order-detail.component.html',
    animations: [slideToTop()]
})
export class OrderDetailComponent implements OnInit {
    orderType: any = 'order';
    status: any;
    skLoading: boolean = false;

    data: any = {};
    login_data: any = [];
    order_id: any;
    order_item: any = [];
    invoice_bill_item: any = [];
    order_logs: any = [];
    order_detail: any = [];
    login_dr_id: any;
    editqty: any = false;
    distrbutorId: any;
    url1: string;
    constructor(public route: ActivatedRoute, public serve: DatabaseService, public toast: ToastrManager, public dialog: MatDialog, public session: sessionStorage, public dialogs: DialogComponent, public router: Router, public alert: DialogComponent) {

        this.login_data = this.session.getSession();
        this.login_data = this.login_data.value.data;

        this.url1 = this.serve.uploadUrl;

        if (this.login_data.access_level != '1') {
            this.login_dr_id = this.login_data.id;
        }

        this.route.params.subscribe(params => {
            // this.order_id = this.serve.crypto(params['id'], false);
            this.order_id = params.id;
            this.serve.currentUserID = params.id
            // this.serve.currentUserID = this.serve.crypto(params['id'], false)
            this.status = this.route.queryParams['_value']['status'];

        });
        this.orderDetail();
    }

    ngOnInit() {


    }



    open_dipatch_model(): void {
        const dialogRef = this.dialog.open(OrderDispatchComponent, {
            width: '1000px', data: {
                order_status: this.order_detail.order_status,
                order_id: this.order_id,
                reason: '',
                drId: this.distrbutorId,
                from: 'order_detail_page'
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result == true) {
                this.orderDetail();
            }
        });
    }

    openEditDialog(user_id, type): void {
        const dialogRef = this.dialog.open(OrderEditModalComponent, {
            width: '400px', data: {
                order_id: this.order_id,
                type: type,
                user_id: user_id
            }

        });

        dialogRef.afterClosed().subscribe(result => {
            if (result != false) {
                this.orderDetail();
            }
        });
    }

    loader: any;
    edit_cash_discount: any = false;
    FsCat: any = false;

    Order_Amount: any;
    orderDetail() {
        this.loader = 1;
        this.skLoading = true;
        let id = { 'id': this.order_id }

        setTimeout(() => {
            this.serve.post_rqst(id, "Order/primaryOrderDetail").subscribe((result => {
                if (result['statusCode'] == 200) {
                    this.skLoading = false;
                    this.order_detail = result['result'];
                    this.distrbutorId = this.order_detail['dr_id'];

                    this.order_item = result['result']['item_info'];
                    this.invoice_bill_item = result['invoice_bill'];
                    this.order_logs = result['result']['order_log'];
                    this.order_detail.order_cgst = this.order_detail.order_gst / 2;
                    this.order_detail.order_cgst = parseFloat(this.order_detail.order_cgst).toFixed(2);
                    this.order_detail.netBreakup = (parseFloat(this.order_detail.order_grand_total) / 1.18)
                    this.order_detail.gstBreakup = parseFloat(this.order_detail.order_grand_total) - parseFloat(this.order_detail.netBreakup)
                    this.order_detail.gstBreakup = this.order_detail.gstBreakup.toFixed(2)
                    this.order_detail.netBreakup = this.order_detail.netBreakup.toFixed(2)
                    this.Order_Amount = Number(this.order_detail.order_total) + Number(this.order_detail.order_discount);


                    for (let i = 0; i < this.order_item.length; i++) {
                        if (this.order_item[i]['brand'] == 'FS') {
                            this.FsCat = true
                        }
                        else {
                            this.FsCat = false;
                        }
                    }

                    this.order_item.map((row) => {
                        row.editqty = false

                    })
                    setTimeout(() => {
                        this.loader = '';

                    }, 700);
                } else {
                    setTimeout(() => {
                        this.loader = '';

                    }, 700);
                    this.skLoading = false;
                    this.toast.errorToastr(result['statusMsg'])
                }
            }))
        }, 700);
    }
    goTODetail(id) {
        this.router.navigate(['/billing-details/' + id], { queryParams: { id } });
    }
    openDialog(): void {

        if(this.order_detail.type==1 && this.order_detail.dr_code=='' ){
            
            this.toast.errorToastr("Kindly Update Account Code")
            return
        }
        const dialogRef = this.dialog.open(StatusModalComponent, {
            width: this.order_detail.order_status == 'dispatchPlanning' || this.order_detail.order_status == 'partialDispatched' ? '' : '400px',
            panelClass: this.order_detail.order_status == 'dispatchPlanning' || this.order_detail.order_status == 'partialDispatched' ? 'min400' : 'cs-model',
            data: {
                'order_status': this.order_detail.order_status,
                'order_id': this.order_id,
                'organisation_name': this.order_detail.organisation_name,
                'from': 'primary_order',
                'order_item': this.order_item,
                'FsCat': this.FsCat,
                reason: ''
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.open_add_item) {
                this.orderDetail();
                this.addItem('despatched');
            } else if (result != false) {
                this.orderDetail();
            }
        });
    }

    deleteOrderitem(order_id, index) {
        this.alert.confirm("You want to delet this item !").then((result) => {
            if (result) {
                this.serve.post_rqst({ 'id': order_id }, "Order/primaryOrderDeleteItem")
                    .subscribe((result => {
                        if (result['status'] == 200) {
                            this.toast.successToastr('Item Deleted Successfully');
                            this.order_item.splice(index, 1)
                            this.orderDetail();
                        } else {
                            this.orderDetail();
                            this.toast.errorToastr(result['status'])
                        }
                    }))
            }
        })
    }

    // }
    order_detail1: any = {}
    edit_qty() {
        this.editqty = true;
    }
    Update_qty(id) {
        let index = this.order_item.findIndex(row => row.id == id)
        let cart_data = []
        let Amount = (this.order_item[index].qty * this.order_item[index].net_price)
        this.order_item[index].product_price = this.order_item[index].price
        this.order_item[index].discounted_price = this.order_item[index].discount_amount
        this.order_item[index].dr_disc = this.order_item[index].discount_percent
        this.order_item[index].amount = Amount
        this.order_item[index].gst_amountbeforfix = (Amount * this.order_item[index].gst_percent) / 100
        this.order_item[index].gst_amount = parseFloat(this.order_item[index].gst_amountbeforfix).toFixed()
        this.order_item[index].total_amount = parseFloat(this.order_item[index].gst_amount) + Amount;
        cart_data.push(this.order_item[index])

        this.serve.post_rqst({ 'id': id, 'cart_data': cart_data }, "order/primaryOrderUpdateItem").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.editqty = false;
                this.toast.successToastr(result['statusMsg']);
                this.orderDetail()
            }
            else {
                this.editqty = false;
                this.toast.errorToastr(result['statusMsg']);
            }
        }))
    }


    amount: any = 0;
    gst_amount: any = 0;
    subtotal: any = 0;
    second_subtotal: any = 0;
    cd_amount: any = 0;

    back() {
        window.history.go(-1);
    }
    addItem(pagetype) {
        let dr_id = this.order_detail.dr_id
        let order_id = this.order_id
        let state = this.order_detail.state
        let type = this.order_detail.type;
        let company_name = this.order_detail.company_name;
        let name = this.order_detail.name;
        let contact_person = this.order_detail.mobile;
        
        this.router.navigate(['/order-list/order-detail', order_id, 'add-item', type, dr_id], {
            queryParams: {
                pagetype: pagetype,
                company_name: company_name,
                name: name,
                contact_person: contact_person,
                state: state
            }
        });
    }

    exportPdf() {
        this.loader = 1;
        this.skLoading = true;
        let id = { 'id': this.order_id }
        this.serve.post_rqst(id, "Order/exportOrderPdf").subscribe((result) => {
            if (result['statusCode'] == 200) {
                this.skLoading = false;
                window.open(this.serve.uploadUrl + 'orderPdf/' + result['file_name']);
                setTimeout(() => {
                    this.loader = '';

                }, 700);
            } else {
                setTimeout(() => {
                    this.loader = '';

                }, 700);
                this.skLoading = false;
                this.toast.errorToastr(result['statusMsg'])
            }
        }
            , err => {
                this.skLoading = false;

            }
        )
    }

    async exportExcelTotal() {
        const ExcelJS = await import('exceljs');

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Order Report');
      
        // Add company name, contact details, and "Created By" rows
        const companyName = 'Company Name: ' + this.order_detail.company_name;
        const contactDetails = 'Contact: ' + this.order_detail.mobile + ' | Name: ' + this.order_detail.name;
        const createdBy = 'Created By: ' + this.order_detail.created_by_name;
      
        // Insert company name (merging across multiple columns)
        worksheet.addRow([companyName]);
        worksheet.mergeCells('A1:J1');
        worksheet.getCell('A1').font = { bold: true, size: 16 };
        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
      
        // Insert contact details
        worksheet.addRow([contactDetails]);
        worksheet.mergeCells('A2:J2');
        worksheet.getCell('A2').font = { italic: true, size: 12 };
        worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'center' };
      
        // Insert created by
        worksheet.addRow([createdBy]);
        worksheet.mergeCells('A3:J3');
        worksheet.getCell('A3').font = { italic: true, size: 12 };
        worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'center' };
      
        // Add an empty row for spacing
        worksheet.addRow([]);
      
        // Define the header row for the order table
        const header = [
          'S No.', 'Brand', 'Category', 'Thickness', 'Size', 'Product Name',
          'QTY.', 'Amount', 'Weight per Sheet', 'Total Weight'
        ];
      
        // Add the header row to the worksheet
        worksheet.addRow(header);
      
        // Apply styles to header row
        worksheet.getRow(5).eachCell({ includeEmpty: true }, (cell) => {
          cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
          cell.alignment = { vertical: 'middle', horizontal: 'center' };
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF4F81BD' } };
          cell.border = {
            top: { style: 'thin' },
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' }
          };
        });
      
        // Variables to store totals
        let totalTonnage = 0;
        let totalQuantity = 0;
        let totalAmount = 0;
      
        // Add data rows from order_item and calculate totals
        this.order_item.forEach((row, index) => {
          const dataRow = [
            index + 1, row.brand, row.product_type, row.thickness, row.size,
            row.product_name, row.qty, row.total_price_with_freight, row.weight + ' KG',
            row.total_weight.toFixed(2) + ' KG'
          ];
          worksheet.addRow(dataRow);
      
          // Accumulate totals
          totalTonnage += parseFloat(row.total_weight);
          totalQuantity += parseInt(row.qty);
          totalAmount += parseFloat(row.total_price);
        });
      
        // Apply alternating row styles for readability
        worksheet.eachRow((row, rowNumber) => {
          if (rowNumber > 5) {
            row.eachCell({ includeEmpty: true }, (cell) => {
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: rowNumber % 2 === 0 ? 'FFCCFFCC' : 'FFFFFFFF' }
              };
              cell.alignment = { vertical: 'middle', horizontal: 'center' };
            });
          }
        });
      
        // Adjust the column widths
        worksheet.columns.forEach((column) => { 
          let maxLength = 0;
          column.eachCell({ includeEmpty: true }, (cell) => {
            const cellValue = cell.value ? cell.value.toString() : '';
            maxLength = Math.max(maxLength, cellValue.length);
          });
          column.width = Math.max(12, maxLength + 2);
        });
      
        worksheet.getColumn(1).width = 8;
        worksheet.getColumn(2).width = 20;
        worksheet.getColumn(3).width = 20;
        worksheet.getColumn(4).width = 15;
        worksheet.getColumn(5).width = 15;
        worksheet.getColumn(6).width = 30;
        worksheet.getColumn(7).width = 15;
        worksheet.getColumn(8).width = 15;
        worksheet.getColumn(9).width = 15;
        worksheet.getColumn(10).width = 15;
      
        // Add total row
        const totalRow = ['', '', '', '', '', 'Total', totalQuantity, totalAmount.toFixed(2), '', totalTonnage.toFixed(2) + ' KG'];
        worksheet.addRow(totalRow);
      
        // Style the total row
        worksheet.getRow(worksheet.lastRow.number).eachCell((cell) => {
          cell.font = { bold: true };
          cell.alignment = { vertical: 'middle', horizontal: 'center' };
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFE699' } };
        });
    
        // Add an empty row for spacing before the financial summary
        worksheet.addRow([]);
      
        // Add the financial summary details (Total Amount, Discount, etc.)
        const financialSummary = [
          ['Total Landing Price', '₹ ' + this.order_detail.order_total.toFixed(2)],
          [`Extra Discount Amount (${this.order_detail.extraDiscountPercentage}%)`, '₹ ' + this.order_detail.extra_discount_amount.toFixed(2)],
          ['Price After Discount', '₹ ' + this.order_detail.priceAfterextraDiscount.toFixed(2)],
          ['GST (18%)', '₹ ' + this.order_detail.totalGSTApplied.toFixed(2)],
          ['Grand Total', '₹ ' + this.order_detail.totalPriceAfterGST.toFixed(2)]
        ];
      
        financialSummary.forEach(([label, value]) => {
          worksheet.addRow([ '','','', '', '', '', '', '',label, value]);
        });
      
        // Style the financial summary rows
        financialSummary.forEach((_, index) => {
          worksheet.getRow(worksheet.lastRow.number - index).eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { vertical: 'middle', horizontal: 'right' };
          });
        });
      
        // Save the Excel file
        workbook.xlsx.writeBuffer().then((buffer) => {
          const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'Order Report.xlsx';
          a.click();
        });
    }
    

     
      
        imageModel(image) {
          const dialogRef = this.dialog.open(ImageModuleComponent, {
            panelClass: 'Image-modal',
            // width: '500px',
            data: {
              image,
            }
          });
          dialogRef.afterClosed().subscribe(result => {
      
          });
        }


//     deleteImageOrder(index,id) {
//       this.serve.post_rqst({ 'id': id}, "CustomerNetwork/deleteCustomerImages").subscribe((result => {
//         if (result['statusCode'] == '200') {
//           this.toast.successToastr(result['statusMsg']);
//           this.orderDetail()
//           this.order_detail.order_images.expBills.splice(index, 1);

//         } else {
//           this.toast.errorToastr(result['statusMsg']);
//         }
//       }
//     ))
//   }

}
